// Bengali
export const bn = {
  'app.name':           'Kardolive',
  'app.tagline':        'গ্রাহক পোর্টাল',
  'app.signOut':        'সাইন আউট',

  'login.email':        'ইমেইল',
  'login.password':     'পাসওয়ার্ড',
  'login.signIn':       'সাইন ইন করুন',
  'login.signingIn':    'সাইন ইন হচ্ছে…',
  'login.failed':       'সাইন ইন ব্যর্থ',
  'login.newAccount':   'Kardolive-এ নতুন?',
  'login.createAccount':'বিনামূল্যে অ্যাকাউন্ট তৈরি করুন →',

  'nav.workspace':      'ওয়ার্কস্পেস',
  'nav.templates':      'টেমপ্লেট',
  'nav.live':           'লাইভ',
  'nav.rooms':          'রুম ও চ্যাট',
  'nav.content':        'কনটেন্ট',
  'nav.developer':      'ডেভেলপার',
  'nav.account':        'অ্যাকাউন্ট',

  'nav.overview':       'সারসংক্ষেপ',
  'nav.projects':       'প্রকল্প',
  'nav.chat':           'চ্যাট কনসোল',
  'nav.sessions':       'সেশন',
  'nav.streams':        'লাইভ স্ট্রিম',
  'nav.studio':         'স্টুডিও',
  'nav.recordings':     'রেকর্ডিং',
  'nav.apiKeys':        'API কী',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'Webhook পরীক্ষক',
  'nav.networkTest':    'নেটওয়ার্ক পরীক্ষা',
  'nav.embed':          'এমবেড উইজেট',
  'nav.sdk':            'SDK ও ডকুমেন্টেশন',
  'nav.docs':           'Developer docs',
  'nav.analytics':      'বিশ্লেষণ',
  'nav.settings':       'সেটিংস',

  'overview.welcome':       'ফিরে আসায় স্বাগতম, {name}',
  'overview.plan':          '{tenant} · {plan} পরিকল্পনা',
  'overview.newStream':     'নতুন স্ট্রিম',
  'overview.kpi.live':           'এখন লাইভ',
  'overview.kpi.live.broadcasting': 'স্ট্রিম সম্প্রচারিত হচ্ছে',
  'overview.kpi.live.nothing':    'কিছুই লাইভ নেই',
  'overview.kpi.total':           'মোট স্ট্রিম',
  'overview.kpi.total.sub':       'সব সময়ে',
  'overview.kpi.sessions':        'সেশন · ৩০ দিন',
  'overview.kpi.sessions.sub':    'প্রকাশনা ইভেন্ট',
  'overview.kpi.recordings':      'রেকর্ডিং',
  'overview.kpi.recordings.sub':  'চালানোর জন্য প্রস্তুত',
  'overview.recentStreams':       'সাম্প্রতিক স্ট্রিম',
  'overview.recentSessions':      'সাম্প্রতিক সেশন',
  'overview.viewAll':             'সব দেখুন →',
  'overview.empty.title':         'এখনও কোনো স্ট্রিম নেই',
  'overview.empty.body':          'সম্প্রচার শুরু করতে আপনার প্রথম স্ট্রিম তৈরি করুন।',
  'overview.empty.action':        'স্ট্রিম তৈরি করুন',
  'overview.noSessions':          'এখনও কোনো সেশন নেই',

  'status.live':        'লাইভ',
  'status.idle':        'নিষ্ক্রিয়',
  'status.ended':       'শেষ হয়েছে',
  'status.archived':    'সংরক্ষিত',

  'common.save':        'সংরক্ষণ',
  'common.cancel':      'বাতিল',
  'common.delete':      'মুছে ফেলুন',
  'common.edit':        'সম্পাদনা',
  'common.create':      'তৈরি করুন',
  'common.confirm':     'নিশ্চিত করুন',
  'common.loading':     'লোড হচ্ছে…',
  'common.error':       'ত্রুটি',
  'common.retry':       'পুনরায় চেষ্টা করুন',

  // Dashboard navigation and account controls.
  "nav.skipContent": "পাতার বিষয়বস্তুতে যান",
  "nav.streamTemplates": "স্ট্রিম টেমপ্লেট",
  "nav.boards": "ইন্টারঅ্যাক্টিভ বোর্ড",
  "nav.menu": "নেভিগেশন খুলুন",
  "nav.closeMenu": "নেভিগেশন বন্ধ করুন",
  "nav.scenarios": "ব্যবহারের পরিস্থিতি",
  "nav.premieres": "প্রিমিয়ার",
  "nav.clips": "ক্লিপ",
  "dashboard.account": "অ্যাকাউন্ট",
  "dashboard.language": "ভাষা",
  "dashboard.appearance": "চেহারা",
  "nav.allStreams": "সব স্ট্রিম",
  "nav.destinations": "সম্প্রচারের গন্তব্য",
  "nav.ecommerce": "ই-কমার্স",
  "nav.products": "পণ্য",
  "nav.services": "পরিষেবা",
  "nav.collections": "সংগ্রহ",
  "nav.orders": "অর্ডার",
  "nav.commerceSettings": "বাণিজ্য সেটিংস",
  "nav.engagement": "অংশগ্রহণ",
  "theme.light": "হালকা মোডে যান",
  "theme.dark": "গাঢ় মোডে যান",
  "role.owner": "মালিক",
  "role.admin": "প্রশাসক",
  "role.member": "সদস্য",
  "role.viewer": "দর্শক",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "সক্রিয়",
  "streams.archived": "আর্কাইভ করা",
  "streams.monitor": "উৎস পর্যবেক্ষণ",
  "streams.create": "লাইভ স্ট্রিম তৈরি করুন",
  "streams.list": "তালিকা",
  "streams.grid": "গ্রিড",
  "streams.view": "স্ট্রিমের দৃশ্য",
  "streams.searchLabel": "ইভেন্ট খুঁজুন",
  "streams.searchHint": "ইভেন্টের নাম খুঁজুন",
  "streams.solutionFilter": "ধরন অনুযায়ী ইভেন্ট ফিল্টার করুন",
  "streams.statusFilter": "অবস্থা অনুযায়ী ইভেন্ট ফিল্টার করুন",
  "streams.dateFilter": "তৈরির তারিখ অনুযায়ী ফিল্টার করুন",
  "streams.allSolutions": "সব ধরন",
  "streams.custom": "বিদ্যমান বা নিজস্ব সেটআপ",
  "streams.allStatuses": "সব অবস্থা",
  "streams.anyTime": "যেকোনো তৈরির তারিখ",
  "streams.last7": "গত ৭ দিনে তৈরি",
  "streams.last30": "গত ৩০ দিনে তৈরি",
  "streams.count": "{total}টি ইভেন্টের মধ্যে {shown}টি দেখানো হচ্ছে",
  "streams.noMatch": "ফিল্টারের সঙ্গে মেলে এমন ইভেন্ট নেই।",
  "streams.clearFilters": "ফিল্টার মুছুন",
  "streams.refreshFailed": "স্ট্রিমের তালিকা হালনাগাদ করা যায়নি",
  "streams.loadFailed": "স্ট্রিম লোড করা যায়নি",
  "streams.stale": "শেষবার লোড করা তালিকা দেখানো হচ্ছে। অবস্থা বদলে থাকতে পারে।",
  "streams.connectionHint": "সংযোগ পরীক্ষা করে তালিকা আবার লোড করুন।",
  "streams.retrying": "আবার চেষ্টা করা হচ্ছে…",
  "streams.retry": "আবার চেষ্টা করুন",
  "streams.restoreFailed": "স্ট্রিম ফিরিয়ে আনা যায়নি",
  "streams.restoreHint": "আবার চেষ্টা করার আগে সংযোগ পরীক্ষা করুন এবং সর্বশেষ অবস্থা জানতে তালিকা হালনাগাদ করুন।",
  "streams.unused": "অব্যবহৃত স্ট্রিম: {count}",
  "streams.unusedHint": "কোনো সম্প্রচার বা রিপ্লে নেই। তালিকা গুছিয়ে রাখতে আর্কাইভ করুন; কিছু মুছে যাবে না।",
  "streams.reviewArchive": "পর্যালোচনা করে আর্কাইভ করুন",
  "streams.loading": "স্ট্রিম লোড হচ্ছে…",
  "streams.archiveEmpty": "আর্কাইভ খালি। আর্কাইভ করা স্ট্রিম ও রিপ্লে ফিরিয়ে না আনা পর্যন্ত এখানে থাকে।",
  "streams.restore": "ফিরিয়ে আনুন",
  "streams.firstTitle": "প্রথম স্ট্রিম তৈরি করুন",
  "streams.firstBody": "বিক্রয়, ক্লাস বা পরিষেবার সেটআপ বেছে নিন, অথবা খালি স্ট্রিম দিয়ে শুরু করুন। ব্রাউজার, ফোন বা OBS থেকে সম্প্রচার করুন।",
  "streams.blank": "খালি স্ট্রিম",
  "streams.broadcasts": "সম্প্রচার: {count}",
  "streams.replays": "রিপ্লে: {count}",
  "streams.sessions": "সেশন: {count}",
  "streams.recordings": "রেকর্ডিং: {count}",
  "streams.mode.BROADCAST": "সম্প্রচার",
  "streams.mode.LOW_LATENCY": "কম বিলম্ব",
  "streams.mode.REALTIME": "রিয়েল-টাইম",
  "streams.key": "কী",
  "streams.archiveTitle": "অব্যবহৃত স্ট্রিম আর্কাইভ করুন",
  "streams.archiveHint": "এই স্ট্রিমগুলো কখনো সম্প্রচার করা হয়নি। আর্কাইভ করা ট্যাব থেকে যেকোনো সময় ফিরিয়ে আনতে পারবেন।",
  "streams.archiveFailed": "{count}টি স্ট্রিম আর্কাইভ করা যায়নি; সেগুলো লাইভ হয়ে থাকতে পারে। বাকিগুলো আর্কাইভ করা হয়েছে।",
  "streams.archiving": "আর্কাইভ করা হচ্ছে…",
  "streams.archiveCount": "{count}টি আর্কাইভ করুন",
  "streamType.webinar": "ব্যবসায়িক ওয়েবিনার ও উদ্বোধন",
  "streamType.classroom": "ক্লাস ও টিউশন",
  "streamType.training": "কর্পোরেট প্রশিক্ষণ",
  "streamType.conference": "সম্মেলন ও প্রদর্শনী",
  "streamType.shopping": "লাইভ কেনাকাটা",
  "streamType.auction": "লাইভ নিলাম",
  "streamType.consultation": "ব্যক্তিগত পরামর্শ",
  "streamType.creator": "ক্রিয়েটর ও কমিউনিটির লাইভ",
  "streamType.audio": "অডিও রুম ও পডকাস্ট",
  "streamType.sports": "খেলা ও ই-স্পোর্টস",
  "streamType.performance": "কনসার্ট ও পরিবেশনা",
  "streamType.community": "উপাসনা ও তহবিল সংগ্রহ",
  "streamType.tour": "ভ্রমণ ও প্রদর্শন",
  "streamType.fitness": "ফিটনেস ও কর্মশালা",
  "streamType.public-meeting": "সংবাদ ও জনসভা",
  "streamType.continuous": "অবিরাম চ্যানেল ও ক্যামেরা",
  "streams.close": "বন্ধ করুন",
};
